import { Suspense } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

import constructorService from './ConstructorService'

function PageRendererService({ page }) {
  const element = page.components[0].elements.content[1].content
  return (
    <Suspense fallback={<div>Carregando elementos...</div>}>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.title} />
        <meta property="og:title" content={page.title} />
        <meta property="og:description" content={page.title} />
        <meta property="og:image" content={page.title} />
      </Helmet>
      <Container>
        <Row id="page">
          <Col xs={12} sm={12} md={12} lg={12} className='destaque border-primaria'>
            {element}
          </Col>
        </Row>
      </Container>
    </Suspense>
  )
}

export default PageRendererService